import {IFormController, INgModelController} from "angular";

export class NgFormUtil {

    public static setPristine(form: IFormController | null) {
        if (form != null) {
            NgFormUtil.reset(form);
            Object.keys(form)
                  .filter(key => !key.startsWith("$"))
                  .map(key => form[key])
                  .map(ctrl => ctrl as INgModelController)
                  .forEach(ctrl => NgFormUtil.reset(ctrl));
        }
    }

    public static reset(ctrl: INgModelController | IFormController) {
        ctrl.$setPristine();
        ctrl.$setUntouched();
    }
}
